/* NELLAE — cart supply upgrade. Replaces the offer line with the next REAL product (never a quantity change).
   Order of operations: add the target first, then remove the old line — the cart is never left empty if a request fails.
   Reversible for the rest of the session ("Switch back to …"). No timers, no urgency. */
(function () {
  'use strict';

  var Nellae = (window.Nellae = window.Nellae || {});
  var SECTION = 'nellae-cart-drawer';
  var KEY = 'nellae_cart_upgrade';
  var config = function () { return Nellae.config || { routes: {}, strings: {} }; };
  var busy = false;

  var post = function (url, payload) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) throw new Error((body && (body.description || body.message)) || 'cart request failed');
        return body;
      });
    });
  };

  var remember = function (value) { try { if (value) sessionStorage.setItem(KEY, JSON.stringify(value)); else sessionStorage.removeItem(KEY); } catch (e) { /* private mode */ } };
  var recall = function () { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } };

  var sync = function () {
    var last = recall();
    document.querySelectorAll('[data-nellae-upgrade-undo]').forEach(function (button) {
      button.hidden = !(last && String(last.toVariant) === button.getAttribute('data-line-variant'));
    });
  };

  var swap = function (root, removeKey, addVariant, done) {
    if (busy) return;
    busy = true;
    root.classList.add('is-loading');
    if (Nellae.cart) Nellae.cart.setError(root, '');
    var routes = config().routes;
    post(routes.cart_add + '.js', { items: [{ id: Number(addVariant), quantity: 1 }] })
      .then(function () {
        return post(routes.cart_change + '.js', { id: removeKey, quantity: 0, sections: SECTION, sections_url: window.location.pathname });
      })
      .then(function (data) {
        done();
        if (root.hasAttribute('data-nellae-cart-page')) { window.location.reload(); return; }
        if (Nellae.cart) Nellae.cart.renderSections(data.sections);
        sync();
      })
      .catch(function () { if (Nellae.cart) Nellae.cart.setError(root, config().strings.cartError || ''); })
      .then(function () { busy = false; root.classList.remove('is-loading'); });
  };

  document.addEventListener('click', function (event) {
    var up = event.target.closest('[data-nellae-upgrade-button]');
    if (up) {
      var box = up.closest('[data-nellae-upgrade]'); var root = up.closest('[data-nellae-cart-root]');
      if (!box || !root) return;
      event.preventDefault();
      var from = parseInt(box.getAttribute('data-from'), 10); var to = parseInt(box.getAttribute('data-to'), 10);
      var toVariant = box.getAttribute('data-to-variant');
      swap(root, box.getAttribute('data-line-key'), toVariant, function () {
        remember({ from: from, to: to, toVariant: toVariant });
        if (Nellae.offers && Nellae.offers.set) Nellae.offers.set(to, 'cart_upgrade');
        if (Nellae.publish) Nellae.publish('cart_upgrade_accepted', { from: from, to: to });
      });
      return;
    }
    var undo = event.target.closest('[data-nellae-upgrade-undo]');
    if (undo) {
      var undoRoot = undo.closest('[data-nellae-cart-root]');
      if (!undoRoot) return;
      event.preventDefault();
      var uFrom = parseInt(undo.getAttribute('data-from'), 10); var uTo = parseInt(undo.getAttribute('data-to'), 10);
      swap(undoRoot, undo.getAttribute('data-line-key'), undo.getAttribute('data-prev-variant'), function () {
        remember(null);
        if (Nellae.offers && Nellae.offers.set) Nellae.offers.set(uTo, 'cart_upgrade_undo');
        if (Nellae.publish) Nellae.publish('cart_upgrade_undone', { from: uFrom, to: uTo });
      });
    }
  });

  // the drawer is re-rendered through the Section Rendering API: re-apply the "switch back" state after every render
  if (Nellae.cart && Nellae.cart.renderSections) {
    var render = Nellae.cart.renderSections;
    Nellae.cart.renderSections = function (sections) { render(sections); sync(); };
  }
  document.addEventListener('DOMContentLoaded', sync);
  sync();
})();
